import React from "react";
import { Tabs, Tab } from "react-bootstrap";

interface TabItem {
  id: number;
  title: string;
  component?: React.ReactNode;
}

interface DynamicTabsProps {
  tabs: TabItem[];
  border?: boolean;
  transparent?: boolean;
  disableNext?: boolean | undefined;
  enableTab?: number[] | undefined;
  currentTab?: number | undefined;
  attop?: boolean;
  currentSelectedTab: (selectedTab: number) => void;
}

const DynamicTabs: React.FC<DynamicTabsProps> = ({
  tabs,
  currentSelectedTab,
  currentTab,
}) => {
  const handleTabSelect = (key: any) => {
    if (key !== null) {
      currentSelectedTab(key);
    }
  };

  const renderTabs = () => {
    return tabs.map((tab) => (
      <Tab key={tab.id} eventKey={tab.id} title={tab.title}>
        {tab.component}
      </Tab>
    ));
  };

  return (
    <Tabs
      activeKey={currentTab}
      onSelect={handleTabSelect}
      id="dynamic-tabs"
      className="dynamic-tabs"
    >
      {renderTabs()}
    </Tabs>
  );
};

export default React.memo(DynamicTabs);
